/** Where a deferred viewport scroll should land, or null to skip it. */
export type ViewportScrollTarget = { scroller: HTMLElement; left: number; top: number } | null

/**
 * Scroll the viewport once a zoom change has re-rendered and laid out: next macrotask, then two
 * animation frames. `resolveTarget` runs at that point (so it reads post-zoom layout), then the
 * rulers re-sync on the following frame.
 */
export function scheduleViewportScroll(
  resolveTarget: () => ViewportScrollTarget,
  syncRulerScrollTransforms: () => void
): void {
  const runScroll = () => {
    const target = resolveTarget()

    if (!target) return

    target.scroller.scrollTo({ left: target.left, top: target.top })
    requestAnimationFrame(() => syncRulerScrollTransforms())
  }

  window.setTimeout(() => {
    requestAnimationFrame(() => requestAnimationFrame(runScroll))
  }, 0)
}
